import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, ProgressSpinnerModule } from 'primeng-lts';
import { AddEditExclusionContainerComponent } from './add-edit-exclusion-container.component';
import { AddEditExclusionComponent } from './add-edit-exclusion.component';

@NgModule({
  declarations: [AddEditExclusionComponent, AddEditExclusionContainerComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    ButtonModule,
    UtilsModule,
  ],
  exports: [AddEditExclusionContainerComponent],
})
export class AddEditExclusionModule {}
